import Keycloak from 'keycloak-js';

import { AUTH } from '@/constants';

const initOptions = {
  url: AUTH.KEYCLOAK.URL,
  realm: AUTH.KEYCLOAK.REALM,
  clientId: AUTH.KEYCLOAK.CLIENT_ID,
};

const keycloak = new Keycloak(initOptions);

let refreshIntervalId;

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async initAuth({ commit, dispatch }) {
    commit('setLoading', true);
    await dispatch('authenticate');
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   */
  async authenticate({ commit, dispatch }) {
    await dispatch('setupClient');
    if (keycloak.authenticated) {
      commit('setToken', keycloak.token);
      refreshIntervalId = setInterval(async () => {
        await dispatch('refreshToken');
      }, AUTH.REFRESH_TOKEN_TIME * 1000);
      await dispatch('fetchProfile');
    }
  },
  /**
   *
   * @param {Function} commit
   */
  async setupClient({ commit }) {
    try {
      await keycloak.init({
        onLoad: AUTH.KEYCLOAK.ON_LOAD.CHECK_SSO,
        checkLoginIframe: false,
      });
    }
    catch {
      commit('setToken', '');
    }
  },
  /**
   *
   * @param {Function} commit
   */
  async refreshToken({ commit }) {
    try {
      const response = await keycloak.updateToken(70);
      if (response) {
        commit('setToken', keycloak.token);
      }
    }
    catch {
      commit('setToken', '');
    }
  },
  /**
   *
   * @param {Function} commit
   */
  async fetchProfile({ commit }) {
    try {
      const profile = await keycloak.loadUserProfile();
      commit('setProfile', profile);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   */
  async logOut({ commit }) {
    clearInterval(refreshIntervalId);
    try {
      await keycloak.logout();
      commit('reset');
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
